import script from "./EvolutionChamber.vue?vue&type=script&setup=true&lang=js"
export * from "./EvolutionChamber.vue?vue&type=script&setup=true&lang=js"

import "./EvolutionChamber.vue?vue&type=style&index=0&id=2592b554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2592b554"]])

export default __exports__